const selectIncidentActions = (state) => state.incidentActions;
export default selectIncidentActions;
